import _ from 'lodash';
let moment = require('moment');

export function getFirstInitial(nickname) {
    if (nickname && nickname.length > 0) {
        return nickname.charAt(0).toUpperCase();
    } else {
        return  null;
    }
}

export function getAge(birthday) {
    return moment().diff(birthday, 'years',false);
}

export function getInt(value) {
    try {
        return parseInt(value);
    } catch (e) {
        console.log('getInt exception', e)
        return 0;
    }
}

export function isOneDayAgo(date) {
    if (!date) {
        return false;
    }

    let now = moment(date);
    let yesterday = moment().subtract(1, 'd');
    let isYesterday = now.isBefore(yesterday);
    return isYesterday;
}

export function generateRandomHexColors(size) {
    return [...Array(size)].map(() => '#'+(Math.random() * 0xFFFFFF << 0).toString(16).padStart(6, '0'));
}

export function isObjectEmpty(obj) {
    if (obj == null) {
        return true;
    }

    return !Object.keys(obj).length;
}

export function toDateTime(date, format) {
    return moment(date).format(format);
}

export function getCurrentDate() {
    return moment();
}

export function deepCopy(arr) {
    return _.cloneDeep(arr);
}

export function orderByDateAsc(items, key, path = null) {
    return items.sort(function(a, b){
        if (path) {
            return new Date(a[path][key]) - new Date(b[path][key]);
        } else {
            return new Date(a[key]) - new Date(b[key]);
        }
    });
}

export function orderByDateDesc(items, key, path = null) {
    return items.sort(function(a, b){
        if (path && path in a && path in b) {
            return new Date(b[path][key]) - new Date(a[path][key]);
        } else {
            return new Date(b[key]) - new Date(a[key]);
        }
    });
}